export default class Login {
	constructor(args) {
		this.flowinfo = args?.get('flowinfo') ?? null;
		this.reason = args?.get('reason') ?? null;
   	this.init();
	}

	init() {
		this.getFlowinfo();
	}

	getFlowinfo() {
		if ( !window.XMLHttpRequest || null == this.flowinfo ) {
			last_page_redirect();
		}

		try {
			var xhr = new XMLHttpRequest();
			xhr.previous_text = '';
			xhr.responseType = "json";

			xhr.onerror = function() {
				console.log('XHR error');
			}
			xhr.onreadystatechange = function() {
				try {

					if (this.readyState == 4 && this.status == 200) {
						if ( this.response.result !== false ) {
							if ( 1 == parseInt(customData?.debug) ) {
								console.log('Login successful, setting cookies...');
							}
							var tmSession = this.response.result.tmSession ?? false;
							var tmAuth = this.response.result.tmAuth ?? false;

							// set cookies and redirect
							let expires = "";
							const date = new Date();
							date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));  // Set cookie to expire in 30 days
							expires = "; expires=" + date.toUTCString();
							let cookieSetting = expires + "; path=/";

							if (tmSession) {
								document.cookie = customData?.cookieContactId + "=" + tmSession + cookieSetting;
							}
							if (tmAuth) {
								document.cookie = customData?.cookieAuth + "=" + tmAuth + cookieSetting;
							}

							setTimeout( function() {
								last_page_redirect();
							}, 1000 );
						}
					}

				} catch (e) {
					console.log(e);
					last_page_redirect();
				}
			}

			xhr.open('POST', customData.ajaxUrl, true);
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
			xhr.send('action=get_flowinfo&flowinfo=' + this.flowinfo + '&reason=' + this.reason);
		} catch (e) {
			console.log('XHR failed request');
			last_page_redirect();
		}
	}
}

function last_page_redirect() {
	let redirect = localStorage.getItem('last_event_page');
	if ( ! redirect || ( redirect && redirect.indexOf(customData.homeUrl) == -1  ) ) {
		redirect = customData.homeUrl;
	}
	if ( localStorage.getItem( 'tm_account_continue' ) && false !== customData?.tm_account_login ) {
		redirect = customData.tm_account_login;
	}
	console.log('redirecting to: ' + redirect);
	window.location.href = redirect;
}
